import React from 'react';

interface CartFooterProps {
  cart: any[];
  onNext: () => void;
}

function CartFooter({ cart, onNext }: CartFooterProps) {
  if (cart.length === 0) return null;

  const totalItems = cart.reduce((sum, item) => sum + item.quantity, 0);
  const totalPrice = cart.reduce((sum, item) => sum + (item.price * item.quantity), 0);

  return (
    <div className="cart-footer">
      <div className="cart-summary">
        <span className="cart-items">{totalItems} artículos</span>
        <span className="cart-total">${totalPrice.toFixed(2)}</span>
      </div>
      <button className="btn-primary" onClick={onNext}>
        Siguiente
      </button>
    </div>
  );
}

export default CartFooter; 